import { render, staticRenderFns } from "./batch_transfer.vue?vue&type=template&id=80d5ee00&scoped=true&"
import script from "./batch_transfer.vue?vue&type=script&lang=js&"
export * from "./batch_transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5ee00",
  null
  
)

export default component.exports